module.exports = __webpack_public_path__ + "static/img/logo.1af33a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share/auth/logo.png
// module id = V4RJ
// module chunks = 1